import { Checkbox } from "baseui/checkbox";
import { Input } from "baseui/input";
import { Select } from "baseui/select";
import { useState } from "react";
import { FormattedMessage } from 'react-intl';

export interface ValueCellSelectorProps {
    dataType: string,
    value: any,
    onValueChanged: any
    valueOptions?: TValueOption[] | undefined // if value is an enum - provide possible values here
}

export type TValueOption = {
    label: string,
    value: number
}

export const ValueCellSelector = (props: ValueCellSelectorProps) => {

    if (props.dataType === 'System.Boolean') {
        return <BooleanCell {...props}></BooleanCell>
    }
    if (props.dataType === 'System.UInt32' && props.valueOptions) {
        return <SelectionCell {...props} valueOptions={props.valueOptions}></SelectionCell>
    }
    if (props.dataType === 'System.Double' || props.dataType === 'System.Single') {
        return <DoubleCell {...props}></DoubleCell>
    }
    return <NumericCell  {...props} />
}


function BooleanCell({ value, onValueChanged }: any) {
    const onValueChange = (e: any) => {
        onValueChanged(e.target.checked);
    }
    return (
        <Checkbox checkmarkType='toggle' labelPlacement='right' checked={value} onChange={onValueChange}>{value === true ? <><FormattedMessage id="on" defaultMessage="ON" /></> : <><FormattedMessage id="off" defaultMessage="OFF" /></>}</Checkbox>
    );
}

function DoubleCell({ value, onValueChanged }: any) {
    const onValueChange = (e: any) => {
        onValueChanged(Number(e.target.value));
    }
    return (
        <Input type='number' value={value} onChange={onValueChange}></Input>
    );
}

function NumericCell({ value, onValueChanged }: any) {
    const onValueChange = (e: any) => {
        var num = Number(e.target.value);

        if (Number.isInteger(num))
            onValueChanged(num);
        else
            onValueChanged(num);
    }

    return (
        <Input type='number' value={value} onChange={onValueChange}></Input>
    );
}

const SelectionCell = (props: { value: any, onValueChanged: (value: number) => void, valueOptions: TValueOption[] }) => {
    const { onValueChanged, valueOptions } = props;
    const [value, setValue] = useState<any[]>([valueOptions.find(v => v.value === props.value)]);

    const onValueChange = (e: any) => {
        setValue(e.value);
        if (e.value.length > 0)
        {
            onValueChanged(e.value[0].id);
        }
            
    }

    return (
        <Select
            options={valueOptions.map((v) => ({ label: v.label, id: v.value}))}
            multi={false}
            value={value}
            clearable={false}
            error={!props.value}
            placeholder="Select a value"
            onChange={onValueChange}
        />
    );
}